// Replicated these exports from researcher code. We'll shifting all dependencies of these constants to quillbot/core from researcher in upcoming microfrontnends.
export type PositonObj = {
  writeAssist: { top: number; left: number };
  tooltip: { top: number; left: number };
};

export enum EditorExecCommands {
  MCERESETDESIGNMODE = 'mceresetdesignmode',
  MCEBEGINUNDOLEVEL = 'mcebeginundolevel',
  MCEENDUNDOLEVEL = 'mceendundolevel',
  MCEADDUNDOLEVEL = 'mceaddundolevel',
  CUT = 'cut',
  COPY = 'copy',
  PASTE = 'paste',
  UNLINK = 'unlink',
  JUSTIFYLEFT = 'justifyleft',
  JUSTIFYCENTER = 'justifycenter',
  JUSTIFYRIGHT = 'justifyright',
  JUSTIFYFULL = 'justifyfull',
  JUSTIFYNONE = 'justifynone',
  INSERTUNORDEREDLIST = 'insertunorderedlist',
  INSERTORDEREDLIST = 'insertorderedlist',
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKETHROUGH = 'strikethrough',
  SUPERSCRIPT = 'superscript',
  SUBSCRIPT = 'subscript',
  FORECOLOR = 'forecolor',
  HILITECOLOR = 'hilitecolor',
  FONTNAME = 'fontname',
  FONTSIZE = 'fontsize',
  LINEHEIGHT = 'lineheight',
  REMOVEFORMAT = 'removeformat',
  MCEBLOCKQUOTE = 'mceblockquote',
  FORMATBLOCK = 'formatblock',
  MCECLEANUP = 'mcecleanup',
  MCEREMOVENODE = 'mceremovenode',
  MCESELECTNODEDEPTH = 'mceselectnodedepth',
  MCESELECTNODE = 'mceselectnode',
  MCEINSERTCONTENT = 'mceinsertcontent',
  MCEINSERTRAWHTML = 'mceinsertrawhtml',
  MCEINSERTNEWLINE = 'mceinsertnewline',
  MCETOGGLEFORMAT = 'mcetoggleformat',
  MCESETCONTENT = 'mcesetcontent',
  INDENT = 'indent',
  OUTDENT = 'outdent',
  MCEREPAINT = 'mcerepaint',
  INSERTHORIZONTALRULE = 'inserthorizontalrule',
  MCETOGGLEVISUALAID = 'mcetogglevisualaid',
  MCEREPLACECONTENT = 'mcereplacecontent',
  MCEINSERTLINK = 'mceinsertlink',
  SELECTALL = 'selectall',
  MCENEWDOCUMENT = 'mcenewdocument',
  INSERTLINEBREAK = 'insertlinebreak',
  UNDO = 'undo',
  REDO = 'redo',
  TOGGLETOOLBARDRAWER = 'toggletoolbardrawer',
  MCENONBREAKING = 'mcenonbreaking',
  INSERTDEFINITIONLIST = 'insertdefinitionlist',
  REMOVELIST = 'removelist',
  MCELISTPROPS = 'mcelistprops',
  MCETOGGLEPLAINTEXTPASTE = 'mcetoggleplaintextpaste',
  MCEINSERTCLIPBOARDCONTENT = 'mceinsertclipboardcontent',
  MCEAPPLYTEXTCOLOR = 'mceapplytextcolor',
  MCEREMOVETEXTCOLOR = 'mceremovetextcolor',
  DELETE = 'delete',
  FORWARDDELETE = 'forwarddelete',
}

export const CitationSpanClassName = 'CitationStyle';
